const LABEL_ERROR = {
  ERROR_PAGE: {
    NOT_FOUND: "/pageNotFound",
    NO_AUTH: "/notAuthenticated",
    NO_ACCESS: "/noAccessToPage",
    COMP_ERROR: "/componentError",
    SERVER_ERROR: "/serverError",
    HOME: "/",
    LOGIN: "/login",
  },
};

const LABEL = Object.freeze(LABEL_ERROR);
export default LABEL;
